import { LAYOUT_PANE_CATEGORIES, LayoutPaneCategoryType } from '../types-and-constants/LayoutPaneTypesAndConstants'

/**
 * @param paneType - pane type string from which a category must be extracted
 * @returns pane category string or null if no category was found
 *
 * First converts the pane type to lowercase and then tries to find a category in it.
 * If a category was found, returns it.
 * If no category was found, returns null.
 * If paneType is undefined, returns null.
 */
export const getPaneCategoryFromPaneType = (paneType?: string): LayoutPaneCategoryType | null => {
    if (paneType === undefined) return null
    const paneCategoriesRegex = new RegExp(`.*(${LAYOUT_PANE_CATEGORIES.join('|')}).*`)
    const paneCategoryRaw: LayoutPaneCategoryType | string = paneType.toLowerCase().replace(paneCategoriesRegex, '$1')
    return LAYOUT_PANE_CATEGORIES.some((pc) => paneCategoryRaw === pc)
        ? (paneCategoryRaw as LayoutPaneCategoryType)
        : null
}
